import React, { useContext, useState } from "react";
import Layout from "../../components/layout/Layout";
import { BsBell } from "react-icons/bs";
import SummaryCard from "../../components/common/SummaryCard";
import { ServiceContext } from "../../hooks/context/ServiceContext";
import Swal from "sweetalert2";
import {
  Button,
 
} from "antd";
import NoData from "../../components/common/NoData";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import SearchInput from "../../components/common/SearchInput";

import Tab from "../Competitions/components/Tab";
import Trigger from "./components/Trigger";
import MessageLogs from "./components/MessageLogs";
import Statistics from "./components/Statistics";
import TriggerFormModal from "./components/TriggerFormModal";
import {
  useCreateTrigger,
  useDeleteTrigger,
  useGetTriggers,
  useUpdateTrigger,
} from "../../hooks/api/notification/notificationService";
import { toast } from "react-toastify";





const NotificationTriggers = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingTrigger, setEditingTrigger] = useState<any>(null);


  // Query parameters
  const [triggerParams, setTriggerParams] = useState({
    page: 1,
    limit: 6,
    search: "",
    is_active: undefined as boolean | undefined,
    trigger_type: "",
  });

  // API hooks
  const {
    data: triggersData,
    isLoading: triggersLoading,
    refetch: refetchTriggers,
  } = useGetTriggers(triggerParams);
  const createTriggerMutation = useCreateTrigger();
  const updateTriggerMutation = useUpdateTrigger();
  const deleteTriggerMutation = useDeleteTrigger();

  const triggers = triggersData?.data?.triggers || [];
  const pagination = triggersData?.data?.pagination;


  const handleOpenDialog = (trigger?: any) => {
    if (trigger) {
      setEditingTrigger(trigger);
    } else {
      setEditingTrigger(null);
    }
    setIsDialogOpen(true);
  };



const handleDelete = async (triggerId: string) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#061638",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await deleteTriggerMutation.mutateAsync(triggerId);
        toast.success('Trigger deleted successfully');
        refetchTriggers();
      } catch (error) {
        toast.error('Failed to delete trigger');
      }
    }
  };

    const handleSearch = (searchTerm: string) => {
    setTriggerParams(prev => ({
      ...prev,
      search: searchTerm,
      page: 1
    }));
  };

  const handlePageChange = (page: number, pageSize: number) => {
    setTriggerParams(prev => ({
      ...prev,
      page,
      limit: pageSize
    }));
  };
  const tabsData = [
    {
      label: "Triggers",
      key: "triggers",
      content: (
        <Trigger
          triggers={triggers}
          loading={triggersLoading}
          total={pagination?.total  || 0}
          currentPage={triggerParams.page}
          pageSize={triggerParams.limit}
          onEdit={handleOpenDialog}
          onDelete={handleDelete}
          onSearch={handleSearch}
          onPageChange={handlePageChange}
        />
      ),
    },
    {
      label: "Message Logs",
      key: "logs",
      content: <MessageLogs />,
    },
    {
      label: "Statistics",
      key: "stats",
      content: <Statistics />,
    },
  ];

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setEditingTrigger(null);
  };

   const handleSubmit = async (formData: any) => {
    try {
      if (editingTrigger) {
        await updateTriggerMutation.mutateAsync({
          id: editingTrigger.id,
          payload: formData
        });
        toast.success('Trigger updated successfully');
      } else {
        await createTriggerMutation.mutateAsync(formData);
        toast.success('Trigger created successfully');
      }
      refetchTriggers();
      handleCloseDialog();
    } catch (error) {
      toast.error('Failed to save trigger');
    }
  };

  return (
    <Layout
      pageName="Notification Engine"
      icon={<BsBell />}
      metricsTitle="Notification Automation"
      showMetrics={false}
      showFilter2={false}
      showTimeLine={false}
      extraChildren={
        <Button
         
          onClick={() => handleOpenDialog()}
           loading={createTriggerMutation.isPending}
          className="whitespace-nowrap bg-primary text-white flex items-center gap-2 px-4 py-6 rounded-md hover:!bg-primary hover:!text-white"
        >
          Create Trigger
        </Button>
      }
    >
      <div className="mt-6">
        <Tab tabsData={tabsData} />
      </div>

      <TriggerFormModal
        isDialogOpen={isDialogOpen}
        editingTrigger={editingTrigger}
        handleSubmit={handleSubmit}
        handleCloseDialog={handleCloseDialog}
                loading={createTriggerMutation.isPending || updateTriggerMutation.isPending}
      />
    </Layout>
  );
};

export default NotificationTriggers;
